<template>
	<div class="schedule-data-item" @click="handleScheduleAction(item)">
		<div class="schedule-data-top">
			<div :style="insetCalendarColorVar(item.calendarThemeColor)" class="schedule-data-type">
				{{ getCalendarName(item.calendarVO.id) }}
			</div>
			<div class="schedule-data-title text-overflow">{{ getScheduleThemeName(item) }}</div>
			<div v-if="formatScheduleDate(item)" class="schedule-data-stime">{{ formatScheduleDate(item) }}</div>
		</div>
	</div>
</template>

<script setup>
import { useScheduleCore, checkScheduleHourHide, getScheduleThemeName } from '@/hooks/calendar/useScheduleCore';
import moment from 'moment';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useCalendarCommon } from '@rebuild/materials/shared/customs_calendar/useCalendarCommon';

defineProps({
	item: {
		type: Object,
		default() {
			return {};
		}
	}
});

const { getCalendarName } = useCalendarCommon();
const { insetCalendarColorVar } = useScheduleCore();

const formatScheduleDate = date => {
	if (!date.scheduleStartTime) return null;
	const disVisibleHour = checkScheduleHourHide(date);
	if (disVisibleHour) {
		return null;
	}
	return `发布时间：${moment(date.scheduleStartTime).format('HH:mm')}`;
};

const { viewModule } = useModuleNavigation();
const handleScheduleAction = item => {
	viewModule('customs_calendar', item);
};
</script>

<style lang="less" scoped>
.schedule-data-item {
	padding: 12px;
	border-radius: 2px;
	transition: all 0.1s ease;
	cursor: pointer;

	&:hover {
		background: #f7f8fa;
	}
	.schedule-data-top {
		display: flex;
		align-items: center;
	}
	.schedule-data-type {
		flex: none;
		padding: 2px 4px;
		background: var(--calendar-fade-1-color);
		color: var(--calendar-color);

		font-size: 10px;

		font-weight: 500;
		line-height: 14px; /* 140% */
		margin-right: 6px;
	}
	.schedule-data-title {
		flex: 1;
		width: 0;
		color: #1d2129;

		font-size: 14px;

		font-weight: 500;
		line-height: 22px; /* 157.143% */
	}
	.schedule-data-stime {
		margin-left: 16px;
		color: #86909c;

		font-size: 12px;

		font-weight: 400;
		line-height: 16px; /* 133.333% */
	}
}
</style>
